import { AuthProvider } from "@/contexts";
import { Outlet, createFileRoute } from "@tanstack/react-router";


const RootLayout = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

export const Route = createFileRoute("/auth")({
  component: RootLayout,
});
